import { useEffect, useState } from "react";
import { Text, useBreakpointValue } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

const Logo: React.FC = () => {
	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const history = useHistory();

	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(false);
	}, [])

	return (
			<Text
				as="button"
				fontSize={["2xl", "3xl"]}
				fontWeight="bold"
				color="white"
				letterSpacing="tight"
				// w={["30", "64"]}
				mb={["2", "0"]}
				onClick={() => history.push('/client')}
			>
				{!isWideVersion && !loading ? "RazioD" : "RazioDigital"}
				<Text as="span" ml="1" color="blue.100" fontSize={40}>.</Text>
			</Text>
	)
}

export default Logo;
